import classNames from "classnames";
import { Form, Formik } from "formik";
import React from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import style from "../../assets/css/components/Form/Form.module.css";
import { socket } from "../../config/socket";
import {
  UpdateLiveInitialState,
  UpdateLiveValidationSchema,
} from "../../utils/match";
import Button from "../Button/Button";
import InputSelect from "../Input/InputSelect";
const MySwal = withReactContent(Swal);

function FormLive({ idMatch }) {
  const options = [
    { value: "true", label: "Iniciar transmisión del partido" },
    { value: "false", label: "Finalizar transmisión del partido" },
  ];

  const handleSubmit = async (values) => {
    const { live } = values;
    // console.log(live);
    socket.emit("liveMatch", { idMatch, live }, (match) => {
      MySwal.fire("Estatus de transmisión cambiado");
      console.log(match);
    });
  };
  return (
    <Formik
      initialValues={UpdateLiveInitialState}
      validationSchema={UpdateLiveValidationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, handleChange, touched, values }) => (
        <Form className={classNames(style.form, style.formLive)}>
          <div className={classNames(style.formColumn, style.twoColumn)}>
            <InputSelect
              error={touched.live && errors.live}
              name="live"
              title="Estatus de transmisión"
              options={options}
              onChange={(selectedOption) => {
                handleChange("live")(selectedOption.value);
              }}
            />
          </div>
          <Button text="Guardar" />
        </Form>
      )}
    </Formik>
  );
}

export default FormLive;
